
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import api from '../../utils/api'

export const fetchCalendarMeetings = createAsyncThunk(
  'calendar/fetchMeetings',
  async ({ advisorId, fromDate, toDate }, thunkAPI) => {
    try {
      let url = `advisor/calendar/${advisorId}`

      // Append date filters if provided
      const params = new URLSearchParams()
      if (fromDate) params.append('from_date', fromDate)
      if (toDate) params.append('end_date', toDate)

      if (params.toString()) {
        url += `?${params.toString()}`
      }

      const response = await api.get(url)
      console.log('calendar fetchCalendarMeetings',response);
      if(response.data.message==="No events found"){
        let res =[]
        return res;
      }

      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error fetching calendar')
    }
  }
)

export const fetchCalendarMeetingsToday = createAsyncThunk(
  'calendar/fetchMeetingsToday',
  async ({ advisorId, today }, thunkAPI) => {
    try {
      const url = `advisor/calendar/${advisorId}?from_date=${today}&end_date=${today}`;
      const response = await api.get(url);
      // console.log('calendar response',response);
      console.log('calendar fetchCalendarMeetings',response.data.message);
      if(response.data.message==="No events found"){
        let res =[]
        return res;
      }
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error fetching today\'s calendar');
    }
  }
);



const calendarSlice = createSlice({
  name: 'calendar',
  initialState: {
    meetings: [],
    todayMeetings: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
    // existing fetchCalendarMeetings
    .addCase(fetchCalendarMeetings.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchCalendarMeetings.fulfilled, (state, action) => {
      state.loading = false;
      state.meetings = action.payload;
    })
    .addCase(fetchCalendarMeetings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // new fetchCalendarMeetingsToday
    .addCase(fetchCalendarMeetingsToday.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchCalendarMeetingsToday.fulfilled, (state, action) => {
      state.loading = false;
      state.todayMeetings = action.payload;
    })
    .addCase(fetchCalendarMeetingsToday.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
  },
})

export default calendarSlice.reducer
